module.exports = __webpack_public_path__ + "fork_straight.svg?f2fc01fe1bef6592999d67bc646e4df5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/fork_straight.svg
// module id = 169
// module chunks = 0